export const GET_LIST_QUANLYTHUCHINGOAILE = "GET_LIST_QUANLYTHUCHINGOAILE";
export const GET_LIST_QUANLYTHUCHINGOAILE_SUCCESS =
  "GET_LIST_QUANLYTHUCHINGOAILE_SUCCESS";
export const GET_LIST_QUANLYTHUCHINGOAILE_FAILURE =
  "GET_LIST_QUANLYTHUCHINGOAILE_FAILURE";

export const UPDATE_SEARCHTDATA_QUANLYTHUCHINGOAILE =
  "UPDATE_SEARCHTDATA_QUANLYTHUCHINGOAILE";
